import React, { useEffect, useCallback, useState} from 'react';
import {downloadImage} from "utils/downloadImage.js"
import Tags from './Tags.js';
import Dropdown from 'react-dropdown';
import {connect} from 'react-redux';

const RecordInfo = ({discogs, records, sample, showTags=true}) => { 
    let [tags, setTags] = useState([]);
    let [record, setRecord] = useState(records[0]);
    useEffect(() => {
        let _records = [...records];
        _records.sort((a,b) => a.year - b.year);
        setRecord(_records[0]);
    }, [records, setRecord]);

    useEffect(() => {
        if (showTags) {
            sample.tags = [... tags];
        }
    }, [tags, sample]);

    useEffect(() => {
        if (record) {
            sample.year = record.year;
            sample.styles = record.genre || [];
            sample.country = record.country;
            sample.discogsId = record.id;
            sample.releaseName = record.title;
            downloadImage(record.thumb).then(
                t => sample.coverArtHash = t);
            discogs.getReleaseInfo(record.id)
                .then(d => {
                    sample.artistName = d.artists[0].name;
                });
        }
    }, [record, sample]);

   
    if (!record) {
        return '';
    }

    let options = records.map(
        r => ({label: r.title + '(' + (r.year) + ')', value: r}));
        
    return (
        <div className="record-info">
          <div className="meta">
            <img src={record.thumb}/>
            <div className="record-meta">
              <div className="record-title">{record.title}</div>
              <div className="record-year">{record.year}</div>
              <div className="record-genre">{record.genre.map(g => <span>{g}</span>)}</div>
            </div>
          </div>
          <div className="others">
            <Dropdown
              onChange={(o) => setRecord(o.value)}
              options={options}
              value={options.find(o => o.value === record)}/>
          </div>
          {showTags ? <Tags tags={tags} setTags={setTags}/> : ''}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RecordInfo);
